<template>
  <v-main v-if="isKeyOk !== null">
    <SignupHeader />

    <v-container class="mt-5">
      <v-layout class="mb-4 mt-4">
        <h2 class="display-1 text-grey-darken-2 text-h4">
          {{ $t('Signup.Title') }}
        </h2>
      </v-layout>

      <!-- 期限切れの場合 -->
      <template v-if="isKeyOk === false">
        <v-container :max-width="700">
          <v-alert
            variant="outlined"
            type="error"
            :value="true"
          >
            {{ $t('Signup.ExpiredMessage') }}
          </v-alert>
          <v-row
            class="mt-3"
            :max-width="700"
          >
            <v-spacer />
            <v-btn
              variant="flat"
              color="secondary"
              @click="$router.push({name: 'Login'})"
            >
              {{ $t('Back') }}
            </v-btn>
          </v-row>
        </v-container>
      </template>

      <!-- 期限内の場合 -->
      <template v-if="isKeyOk === true">
        <!-- 登録画面 -->
        <template v-if="!isSubmit">
          <TwoColumnPageLayout>
            <!-- 最初のユーザー-->
            <template #first>
              <SimpleCard :title="$t('User.FirstUser')">
                <UserForm
                  nest-key="users"
                  registration-mode
                  :pre-email="preEmail"
                  @form-data="updateUserFormData"
                />
                <v-alert
                  :value="true"
                  type="info"
                >
                  {{ $t('User.Info1') }}
                </v-alert>
              </SimpleCard>
            </template>
            <!-- 組織 -->
            <template #second>
              <SimpleCard :title="$t('Customer.Customer')">
                <CustomerForm
                  nest-key="customers"
                  @form-data="updateCustomerFormData"
                />
              </SimpleCard>
            </template>
          </TwoColumnPageLayout>

          <v-layout>
            <v-spacer />
            <ActionButton
              cancel
              @click="$router.push({name: 'Login'})"
            />
            <ActionButton
              class="ml-3"
              save
              @click="submit()"
            />
          </v-layout>
        </template>

        <!-- 登録成功画面 -->
        <v-slide-y-transition>
          <div v-if="isSubmit">
            <v-card
              class="mt-5 align-content-center"
              elevation="0"
            >
              <template #prepend>
                <v-icon
                  color="success"
                  class="justify-center"
                  style="font-size: 150px;"
                >
                  mdi-check-circle
                </v-icon>
              </template>
              <v-card-text class="mb-4">
                <h2
                  style="font-weight: normal"
                  class="text-grey-darken-1"
                >
                  {{ $t('Signup.SuccessMessage') }}
                </h2>
              </v-card-text>

              <v-card-actions class="mt-4">
                <v-btn
                  color="secondary"
                  @click="redirectLoginPage()"
                >
                  <v-icon class="mr-2">
                    mdi-arrow-right
                  </v-icon>
                  {{ $t('User.Login') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-slide-y-transition>
      </template>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters } from 'vuex'
import UserForm from '../../components/forms/UserForm'
import http from '../../library/no_session_http'
import SimpleCard from '../../components/parts/card/SimpleCard'
import ActionButton from '../../components/parts/button/ActionButton'
import CustomerForm from '../../components/forms/CustomerForm'
import TwoColumnPageLayout from '../../components/pages/layouts/TwoColumnPageLayout'
import SignupHeader from '../../components/content/SignupHeader'

export default {
  components: {
    SignupHeader,
    TwoColumnPageLayout,
    CustomerForm,
    ActionButton,
    SimpleCard,
    UserForm
  },
  props: {},
  data: () => ({
    formData: {
      key: null,
      users: {},
      customers: {}
    },
    isKeyOk: null,
    isSubmit: false,
    preEmail: null
  }),
  computed: {
    ...mapGetters(['errorRes', 'ui'])
  },
  created () {
    this.$store.dispatch('clearErrorRes')
    if (!this.$route.query.key) {
      this.$router.push({ name: 'Login' })
    } else {
      this.checkKey()
    }
  },
  methods: {
    checkKey () {
      http.get('signup/', { params: { key: this.$route.query.key } }).then(
        (res) => {
          this.isKeyOk = true
          this.preEmail = res.data
        },
        (error) => {
          if (error.response.data && error.response.data.detail === 'Signature has expired.') {
            this.isKeyOk = false
          } else {
            this.redirectLoginPage()
          }
        }
      )
    },
    updateUserFormData (data) {
      this.formData.users = data
    },
    updateCustomerFormData (data) {
      this.formData.customers = data
    },
    submit () {
      this.formData.key = this.$route.query.key
      this.formData.users.email = this.preEmail
      // do nothing if there is no password
      if (!this.formData.users.password) return

      http.post('signup/', this.formData).then(
        (res) => {
          this.isSubmit = true
        },
        (error) => {
          if (error.response.data && error.response.data.detail === 'Signature has expired.') {
            this.isKeyOk = false
          }
        }
      )
    },
    redirectLoginPage () {
      location.href = '/login'
    }
  }
}
</script>

<style scoped>
</style>
